__turbopack_context__.v({
  "breakDownTableBox": "z8lDsW_breakDownTableBox",
  "discount": "z8lDsW_discount",
  "itemBox": "z8lDsW_itemBox",
  "itemContent": "z8lDsW_itemContent",
  "itemText": "z8lDsW_itemText",
  "price": "z8lDsW_price",
  "subItemContent": "z8lDsW_subItemContent",
  "subItemPrice": "z8lDsW_subItemPrice",
  "subItemText": "z8lDsW_subItemText",
  "total": "z8lDsW_total",
});
